import { Link } from "react-router-dom";
import { useState } from "react";
import api from "../api/api";
import FooterLogo from "../assets/images/footer-logo.png";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";


export default function Footer({ setToast }) {


    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);



    const handleSubscribe = async () => {

        if (!email) {
            setToast?.({
                message: "Please enter your email"
            });
            return;
        }


        setLoading(true);


        try {

            const { data } = await api.post("/subscribe", {
                email,
            });


            setToast?.({
                message:
                    data.message ||
                    "Subscribed successfully 🎉",
            });


            setEmail("");


        } catch (error) {

            setToast?.({
                message:
                    error.response?.data?.message ||
                    "Subscription failed. Try again.",
            });


        } finally {

            setLoading(false);

        }

    };



    return (

        <footer
            className="
            relative
            mt-24
            bg-[#111827]
            dark:bg-[#09090b]
            text-gray-300
            "
        >


            <div className="container mx-auto px-6 py-16">



                {/* NEWSLETTER */}

                <div
                    className="
                    relative
                    overflow-hidden
                    rounded-3xl
                    bg-gradient-to-r
                    from-[#0F766E]
                    via-[#115e59]
                    to-[#D9BB74]
                    p-8
                    md:p-12
                    mb-16
                    "
                >


                    <div
                        className="
                        absolute
                        -top-20
                        -right-20
                        w-72
                        h-72
                        bg-white/20
                        rounded-full
                        blur-3xl
                        "
                    />



                    <div className="
                        relative
                        grid
                        md:grid-cols-2
                        gap-10
                        items-center
                    ">



                        <div>

                            <h2
                                className="
                                text-3xl
                                md:text-4xl
                                font-bold
                                text-white
                                "
                            >
                                Get Exclusive UAE Hotel Deals ✨
                            </h2>


                            <p
                                className="
                                mt-4
                                text-white/80
                                leading-7
                                max-w-lg
                                "
                            >
                                Subscribe and receive luxury hotel offers,
                                Dubai travel deals, and special discounts
                                directly in your inbox.
                            </p>


                            <p
                                className="
                                mt-5
                                text-sm
                                text-white/70
                                "
                            >
                                ✓ No spam &nbsp; ✓ Best UAE hotel prices
                            </p>


                        </div>




                        <div
                            className="
                            bg-white/10
                            backdrop-blur-xl
                            border
                            border-white/20
                            rounded-2xl
                            p-6
                            "
                        >


                            <input

                                type="email"

                                value={email}

                                onChange={(e) => setEmail(e.target.value)}

                                placeholder="Enter your email"

                                className="
                                w-full
                                rounded-xl
                                px-5
                                py-3
                                bg-white
                                text-gray-900
                                outline-none
                                focus:ring-2
                                focus:ring-[#D9BB74]
                                "
                            />



                            <button

                                onClick={handleSubscribe}

                                disabled={loading}

                                className="
                                mt-4
                                w-full
                                rounded-xl
                                bg-[#D9BB74]
                                py-3
                                font-semibold
                                text-[#1B1B1B]
                                transition
                                hover:bg-white
                                disabled:opacity-50
                                "
                            >

                                {
                                    loading
                                        ?
                                        "Subscribing..."
                                        :
                                        "Subscribe For Deals"
                                }

                            </button>



                        </div>


                    </div>


                </div>







                {/* FOOTER GRID */}


                <div
                    className="
                    grid
                    grid-cols-1
                    sm:grid-cols-2
                    lg:grid-cols-4
                    gap-10
                    border-b
                    border-gray-800
                    pb-12
                    ">


                    {/* BRAND */}

                    <div>


                        <Link to="/">

                            <img
                                src={FooterLogo}
                                alt="UAE Dubai Hotels"
                                className="
                                h-20
                                object-contain
                                "
                            />

                        </Link>



                        <p
                            className="
                            mt-5
                            text-sm
                            leading-7
                            text-gray-400
                            "
                        >
                            Discover luxury hotels, resorts and
                            exclusive stays across Dubai,
                            Abu Dhabi and UAE destinations.
                        </p>


                    </div>






                    {/* LINKS */}


                    <div>


                        <h3
                            className="
                            text-white
                            font-semibold
                            mb-5
                            "
                        >
                            Explore
                        </h3>


                        <div className="space-y-3 text-gray-400">

                            <Link
                                to="/"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Home
                            </Link>


                            <Link
                                to="/hotels"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Hotels
                            </Link>


                            <Link
                                to="/blogs"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Travel Blog
                            </Link>


                            <Link
                                to="/contact-us"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Contact
                            </Link>

                        </div>


                    </div>







                    {/* SUPPORT */}


                    <div>

                        <h3 className="text-white font-semibold mb-5">
                            Support
                        </h3>


                        <div className="space-y-3 text-gray-400">

                            <Link
                                to="/faqs"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                FAQ
                            </Link>


                            <Link
                                to="/privacy-policy"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Privacy Policy
                            </Link>


                            <Link
                                to="/terms-conditions"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Terms & Conditions
                            </Link>


                            <Link
                                to="/contact-us"
                                className="block hover:text-[#D9BB74] transition"
                            >
                                Help Center
                            </Link>

                        </div>

                    </div>







                    {/* CONTACT */}


                    <div className="max-w-sm">

                        <h3 className="text-white font-semibold mb-6">
                            Contact
                        </h3>


                        <div className="space-y-5 text-gray-400">


                            {/* Phone */}
                            <a
                                href="tel:+971501234567"
                                className="
                flex
                items-start
                gap-3
                hover:text-[#D9BB74]
                transition
            "
                            >
                                <FiPhone
                                    className="
                    text-[#D9BB74]
                    mt-1
                    flex-shrink-0
                "
                                />

                                <span className="leading-6">
                                    +971 50 123 4567
                                </span>

                            </a>



                            {/* Email */}
                            <a
                                href="mailto:info@southtravels.com"
                                className="
                flex
                items-start
                gap-3
                hover:text-[#D9BB74]
                transition
            "
                            >
                                <FiMail
                                    className="
                    text-[#D9BB74]
                    mt-1
                    flex-shrink-0
                "
                                />

                                <span className="leading-6">
                                    info@southtravels.com
                                </span>

                            </a>



                            {/* Location */}
                            <div
                                className="
                flex
                items-start
                gap-3
            "
                            >

                                <FiMapPin
                                    className="
                    text-[#D9BB74]
                    mt-1
                    flex-shrink-0
                "
                                />

                                <span className="leading-6">
                                    Office 302, 3rd Flr. HDS Tower Cluster F,
                                    <br />
                                    Jumeirah Lakes Towers Dubai,
                                    <br />
                                    United Arab Emirates
                                </span>

                            </div>


                        </div>



                        {/* Social Icons */}
                        <div className="flex items-center gap-4 mt-7">


                            <a
                                href="https://www.facebook.com/SouthTravelsUAE/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="
                w-9
                h-9
                rounded-full
                bg-white/5
                flex
                items-center
                justify-center
                hover:bg-[#D9BB74]
                hover:text-[#1B1B1B]
                transition
            "
                            >
                                <FaFacebookF />
                            </a>



                            <a
                                href="https://www.instagram.com/southtravels8376/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="
                w-9
                h-9
                rounded-full
                bg-white/5
                flex
                items-center
                justify-center
                hover:bg-[#D9BB74]
                hover:text-[#1B1B1B]
                transition
            "
                            >
                                <FaInstagram />
                            </a>



                            <a
                                href="https://twitter.com/SouthTravels"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="
                w-9
                h-9
                rounded-full
                bg-white/5
                flex
                items-center
                justify-center
                hover:bg-[#D9BB74]
                hover:text-[#1B1B1B]
                transition
            "
                            >
                                <FaTwitter />
                            </a>



                            <a
                                href="https://api.whatsapp.com/send?phone=971502477593&text=Hi%2C%20I%20would%20like%20to%20inquire%20about%20something.%20I%20found%20your%20website%20at%20https%3A%2F%2Fwww.southtravels.com%2F"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="
                w-9
                h-9
                rounded-full
                bg-white/5
                flex
                items-center
                justify-center
                hover:bg-[#D9BB74]
                hover:text-[#1B1B1B]
                transition
            "
                            >
                                <FaWhatsapp />
                            </a>


                        </div>


                    </div>



                </div>







                {/* WHATSAPP */}


                <a
                    href="https://wa.me/971502477593"
                    target="_blank"
                    rel="noopener noreferrer"

                    className="
                    fixed
                    right-0
                    top-1/2
                    -translate-y-1/2
                    z-50
                    "
                >


                    <div
                        className="
    bg-[#25D366]
    rounded-l-2xl
    px-4
    py-5
    shadow-xl
    flex
    flex-col
    items-center
    gap-3
    hover:px-6
    transition-all
    duration-300
    animate-pulse
    relative
    before:absolute
    before:inset-0
    before:bg-[#25D366]
    before:rounded-l-2xl
    before:animate-ping
    before:opacity-20
    "
                    >

                        <div className="relative z-10 animate-bounce">
                            <FaWhatsapp
                                className="
            text-white
            text-3xl
            drop-shadow-lg
            "
                            />
                        </div>

                        <span
                            className="
        relative
        z-10
        text-white
        text-xs
        font-bold
        uppercase
        [writing-mode:vertical-rl]
        rotate-180
        "
                        >
                            Chat Now
                        </span>

                    </div>


                </a>







                {/* COPYRIGHT */}


                <div
                    className="
                    pt-8
                    flex
                    flex-col
                    md:flex-row
                    justify-between
                    items-center
                    text-sm
                    text-gray-500
                    "
                >


                    <p>
                        © {new Date().getFullYear()} UAE Dubai Hotels.
                        All rights reserved.
                    </p>



                    <p className="mt-3 md:mt-0">
                        Luxury stays & exclusive UAE hotel deals ✈️
                    </p>


                </div>



            </div>


        </footer>

    );

}